import React from "react";
import { useTranslation } from "../../useTranslation";
import {
  Button,
  Box,
  Link,
  Typography
} from "@vp/swan";

interface GuestCheckoutButtonProps {
  guestReturnUrl: string | undefined;
  name?: string;
  wrappedProps?: any;
  guestCheckoutText: string;
  guestCheckoutAccessibilityLabel: string;
}

const GuestCheckoutButtonControl: React.FC<GuestCheckoutButtonProps> = ({
  guestReturnUrl,
  name,
  wrappedProps,
  guestCheckoutText,
  guestCheckoutAccessibilityLabel
}) => {
  const [t] = useTranslation();
  // Columns shouldn't span further than certain width on larger screens

  return (
    <>
      <Button
        href={guestReturnUrl}
        component={Link}
        mb={3}
        data-testid="guest-checkout-button"
        name={name}
        skin="primary"
        width="full-width"
        aria-label={name}
        {...wrappedProps}
      >
        {guestCheckoutText}
      </Button>
      <Box mb="between-actions">
        <Typography fontSkin="body-small">
          {String(t("app:loadingText", {}))}
        </Typography>
      </Box>
      <Box visuallyHidden aria-live="polite">
        {guestCheckoutAccessibilityLabel}
      </Box>
    </>
  );
};

const GuestCheckoutButton: React.FunctionComponent<GuestCheckoutButtonProps> = React.memo(
  GuestCheckoutButtonControl
);
export default GuestCheckoutButton;
